import { render, staticRenderFns } from "./transferView.vue?vue&type=template&id=4a9c0d38&scoped=true&"
import script from "./transferView.vue?vue&type=script&lang=js&"
export * from "./transferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c0d38",
  null
  
)

export default component.exports